import { NavigationActions, StackActions } from 'react-navigation';
import { DRNUtil } from '@traveloka/district-util';

let _navigator;

function setTopLevelNavigator(navigator) {
  _navigator = navigator;
}

function getNavigator() {
  return new Promise(resolve => {
    if (_navigator) {
      resolve(_navigator);
      return;
    }
    const interval = setInterval(() => {
      if (_navigator) {
        resolve(_navigator);
        clearInterval(interval);
      }
    }, 50);
  });
}

function dispatch(...args) {
  getNavigator().then(navigator => navigator.dispatch(...args));
}

function push(routeName, params) {
  dispatch(
    StackActions.push({
      routeName,
      params,
    })
  );
}

function navigateFromRoot(routeName, params) {
  if (DRNUtil.isWeb()) {
    // push instead reset/navigate to make sure navigation state is
    // moving forward instead pop to back state, as it will make state
    // mismatch with browser history state
    dispatch(StackActions.push({ routeName: 'Home' }));
    dispatch(StackActions.push({ routeName, params }));
  } else {
    dispatch(
      StackActions.reset({
        index: 1,
        actions: [
          NavigationActions.navigate({ routeName: 'Home' }),
          NavigationActions.navigate({ routeName, params }),
        ],
      })
    );
  }
}

function goBack() {
  dispatch(NavigationActions.back());
}

export default {
  setTopLevelNavigator,
  push,
  navigateFromRoot,
  goBack,
};
